import axios from 'axios';
import {API_ROOT} from '../app/utils';
import {isUpgradeToBusinessPopup} from './popupActions';

export function fetchContactsHistoryLogs (filter = {}) {
	return function (dispatch) {
		dispatch({ type: 'FETCH_CONTACTS_HISTORY_LOGS_PENDING', payload: filter });

		const params = new URLSearchParams();
		if (filter.page) params.append('page', filter.page);
		if (filter.pageSize) params.append('pageSize', filter.pageSize);
		if (filter.domainLogs) params.append('domainLogs', filter.domainLogs);
		if (filter.groupId) params.append('groupId', filter.groupId);
		if (filter.contactId) params.append('contactId', filter.contactId);
		if (filter.authorId) params.append('authorId', filter.authorId);
		if (filter.action) params.append('action', filter.action);
		if (filter.startDate) params.append('startDate', filter.startDate);
		if (filter.endDate) params.append('endDate', filter.endDate);
		if (filter.query) params.append('query', filter.query);

		const queryString = params.toString();
		const url = `${API_ROOT}/api/v1/history/contacts${queryString ? `?${queryString}` : ''}`;

		return axios.get(url, {withCredentials: true}).then((response) => {
			dispatch({
				type: 'FETCH_CONTACTS_HISTORY_LOGS_SUCCESS',
				payload: response.data,
				filter
			});
			return response.data;
		}).catch(e => {
			const errorData = e.response ? e.response.data : { message: e.message };
			if (e.response && e.response.status === 403 && errorData.code === 'PLAN_UPGRADE_REQUIRED') {
				dispatch({
					type: 'FETCH_CONTACTS_HISTORY_LOGS_UPGRADE_REQUIRED',
					payload: errorData
				});
				dispatch(isUpgradeToBusinessPopup(true));
			} else {
				dispatch({
					type: 'FETCH_CONTACTS_HISTORY_LOGS_FAILURE',
					payload: errorData
				});
			}
			throw errorData;
		});
	};
}

export function fetchNextContactsHistoryLogs (page, filter = {}) {
	return function (dispatch, getState) {
		const stateFilters = getState()?.contactsHistoryLogsReducer?.filters || {};
		const effectiveFilter = { ...stateFilters, ...filter };

		const params = new URLSearchParams();
		params.append('page', page);
		if (effectiveFilter.pageSize) params.append('pageSize', effectiveFilter.pageSize);
		if (effectiveFilter.domainLogs) params.append('domainLogs', effectiveFilter.domainLogs);
		if (effectiveFilter.groupId) params.append('groupId', effectiveFilter.groupId);
		if (effectiveFilter.contactId) params.append('contactId', effectiveFilter.contactId);
		if (effectiveFilter.authorId) params.append('authorId', effectiveFilter.authorId);
		if (effectiveFilter.action) params.append('action', effectiveFilter.action);
		if (effectiveFilter.startDate) params.append('startDate', effectiveFilter.startDate);
		if (effectiveFilter.endDate) params.append('endDate', effectiveFilter.endDate);
		if (effectiveFilter.query) params.append('query', effectiveFilter.query);

		const url = `${API_ROOT}/api/v1/history/contacts?${params.toString()}`;

		return axios.get(url, {withCredentials: true}).then((response) => {
			dispatch({
				type: 'FETCH_NEXT_CONTACTS_HISTORY_LOGS_SUCCESS',
				payload: response.data
			});
			dispatch(loadNextContactsHistory(false));
			return response.data;
		}).catch(e => {
			dispatch(loadNextContactsHistory(false));
			const errorData = e.response ? e.response.data : { message: e.message };
			if (e.response && e.response.status === 403 && errorData.code === 'PLAN_UPGRADE_REQUIRED') {
				dispatch(isUpgradeToBusinessPopup(true));
			}
		});
	};
}

export function revertContactHistory (historyId) {
	return function (dispatch) {
		dispatch({ type: 'REVERT_CONTACT_HISTORY_PENDING', payload: historyId });
		return axios.post(`${API_ROOT}/api/v1/history/contacts/${historyId}/revert`, {}, {withCredentials: true})
			.then(response => {
				dispatch({
					type: 'REVERT_CONTACT_HISTORY_SUCCESS',
					payload: response.data,
					historyId
				});
				return response.data;
			})
			.catch(e => {
				const errorData = e.response ? e.response.data : { message: e.message };
				if (e.response && e.response.status === 403 && errorData.code === 'PLAN_UPGRADE_REQUIRED') {
					dispatch(isUpgradeToBusinessPopup(true));
				}
				dispatch({
					type: 'REVERT_CONTACT_HISTORY_FAILURE',
					payload: errorData,
					historyId
				});
				throw errorData;
			});
	};
}

export function restoreContactHistory (historyId, targetGroupId = null) {
	return function (dispatch) {
		dispatch({ type: 'RESTORE_CONTACT_HISTORY_PENDING', payload: { historyId, targetGroupId } });
		const url = `${API_ROOT}/api/v1/history/contacts/${historyId}/restore${targetGroupId ? `?targetGroupId=${encodeURIComponent(targetGroupId)}` : ''}`;
		return axios.post(url, {}, {withCredentials: true})
			.then(response => {
				dispatch({
					type: 'RESTORE_CONTACT_HISTORY_SUCCESS',
					payload: response.data,
					historyId
				});
				return response.data;
			})
			.catch(e => {
				const errorData = e.response ? e.response.data : { message: e.message };
				if (e.response && e.response.status === 403 && errorData.code === 'PLAN_UPGRADE_REQUIRED') {
					dispatch(isUpgradeToBusinessPopup(true));
				}
				dispatch({
					type: 'RESTORE_CONTACT_HISTORY_FAILURE',
					payload: errorData,
					historyId
				});
				throw errorData;
			});
	};
}

export function loadNextContactsHistory (boolean) {
	return {
		type: 'LOAD_NEXT_CONTACTS_HISTORY',
		payload: boolean
	};
}

